// extracted by mini-css-extract-plugin
export default {"left":"Section3_left__Sn5DL","right":"Section3_right__pmyY5","leftText":"Section3_leftText__HEivY","rightText":"Section3_rightText__j0Q+F","img":"Section3_img__QrX4p"};